module.exports = __webpack_public_path__ + "static/img/xinnet-bg.5fbb247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/xinnet-bg.png
// module id = 2eC3
// module chunks = 1